
import Clipboard from "../../../assets/filled/Clipboard.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ClipboardIcon({ className, dataTestid = "ClipboardIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Clipboard data-testid={dataTestid} className={classes} {...rest} />
  );
}
